import type { HTMLAttributes, Ref } from "react";
import { cn } from "@/lib/utils";
export function GlassPanel({
  className,
  ref,
  ...props
}: HTMLAttributes<HTMLDivElement> & {
  ref?: Ref<HTMLDivElement>;
}) {
  return <div ref={ref} className={cn("rounded-panel border border-[var(--glass-border)] bg-[var(--glass-bg)] shadow-glass backdrop-blur-[20px]", className)} {...props} data-sentry-component="GlassPanel" data-sentry-source-file="GlassPanel.tsx" />;
}